import { Injectable } from '@angular/core';
import { BaseAuthenticatedService } from './base-authenticated.service';
import { HttpClient } from '@angular/common/http';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Observable } from 'rxjs';
import {
  httpQueryParams,
  PaginatedResponse,
} from './base-authenticated.service';
import { ActivatedRoute } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class ExtraPaidServicesApiService extends BaseAuthenticatedService {
  constructor(
    public override auth: AngularFireAuth,
    public override httpClient: HttpClient, // private cookieService: CookieService
    private route: ActivatedRoute, // Inject ActivatedRoute
  ) {
    super(auth, httpClient);
  }

  public getExtrapaidservicesList<T = ExtraPaidServicesApiService>(
    organization_id: Number | null,
    params: httpQueryParams = {},
  ): Observable<PaginatedResponse<T>> {
    if (!organization_id) {
      throw new Error('Organization ID is required');
    }
    let path = `api/${organization_id}/extraservice/`;
    return this.getList<T>(path, params);
  }
}
